import VueStore from "../../store/VueStore";
import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { GraphSettings } from "../../types/types";
import { Auth } from "aws-amplify";
import moment from "moment";
import router from "@/router";

export default class CognitoController {

  public static refreshToken() {
    const nowTime: number = Number(moment().format("X"));
    const expTime: number = VueStore.state.expTime;
    if (expTime < nowTime) {
      Auth.currentSession().then((user: CognitoUserSession) => {
        const newToken: string = user.getIdToken().getJwtToken();
        // const newRefreshToken = user.getRefreshToken();
        const newExpTime = user.getIdToken().decodePayload().exp;
        VueStore.commit("setToken", newToken);
        VueStore.commit("setExpTime", newExpTime);
        return;
      }).catch((err: any) => {
        console.error(err);
        Auth.signOut().then(() => {
          return router.push("/signIn");
        });
      });
    } else {
      return;
    }
  }

  protected graphSettings: GraphSettings;

  constructor() {
    this.graphSettings = this.getGraphSettings();
  }

  public getGraphSettings() {
    return JSON.parse(localStorage.getItem("graphSettings"));
  }

  public setGraphTypes(value: string[]) {
    this.graphSettings.graphTypes = value;
  }

  public setGraphIDs(value: number[]) {
    this.graphSettings.graphIDs = value;
  }

  public setSignallampIDs(value: number[]) {
    this.graphSettings.signallampIDs = value;
  }

  public setUseSignal(value: boolean) {
    this.graphSettings.useSignal = value;
  }

  public setUsePresence(value: boolean) {
    this.graphSettings.usePresence = value;
  }

  public setUseTimeZone(value: string) {
    this.graphSettings.useTimeZone = value;
  }

  public update() {
    return new Promise((resolve, reject) => {
      Auth.currentUserPoolUser().then((user: CognitoUser) => {
        // TODO: パトランプ(sigtia)・席ティア(仮)の設定をONにする
        // TODO: 本番へ反映する際にはコメントアウト必須
        // this.graphSettings.useSignal = true;
        // this.graphSettings.usePresence = true;
        Auth.updateUserAttributes(user, { "custom:graphSettings": JSON.stringify(this.graphSettings) }).then((result) => {
          localStorage.setItem(
            "graphSettings",
            JSON.stringify(this.graphSettings),
          );
          return resolve(result);
        });
      }).catch((err: any) => {
        console.error(err);
        return reject(err);
      });
    });
  }
}
